import { compose } from 'redux';
import { Grid, Button } from '@material-ui/core';
import { Formik, Form, Field } from 'formik';
import withStyles from '@material-ui/styles/withStyles';
import TextFieldFormik from 'app/components/form/formik/TextFieldFormik';
import DatePickerFormik from 'app/components/form/formik/DatePickerFormik';
import SelectTextFieldFormik from 'app/components/form/formik/SelectTextFieldFormik';
import { Format } from 'app/app.constants';
import {
  ACTIVITY_LOG_STATUSES,
  Filters,
} from 'features/wells/overview/activityLog/helpers/activityLog.constants';

const ActivityLogFilter = ({ classes, onSubmit, initialValues }) => {
  return (
    <Formik
      enableReinitialize
      onSubmit={onSubmit}
      initialValues={initialValues}
    >
      <Form>
        <Grid xs item container>
          <Grid item xs classes={{ root: classes.filterSpacing }}>
            <Field
              fullWidth
              label="Name"
              margin="none"
              name={Filters.NAME}
              component={TextFieldFormik}
              placeholder="Search..."
            />
          </Grid>
          <Grid item xs={3} classes={{ root: classes.filterSpacing }}>
            <SelectTextFieldFormik
              label="Status"
              margin="none"
              items={ACTIVITY_LOG_STATUSES}
              emptyText="All"
              name={Filters.STATUS}
              getItemValue={(status) => status.id}
              getItemName={(status) => status.name}
            />
          </Grid>
          <Grid item xs classes={{ root: classes.filterSpacing }}>
            <Field
              fullWidth
              label="From"
              margin="none"
              name={Filters.FROM}
              component={DatePickerFormik}
              placeholder={Format.date_dayfirst}
              format={Format.date_dayfirst}
            />
          </Grid>
          <Grid item xs classes={{ root: classes.filterSpacing }}>
            <Field
              fullWidth
              label="To"
              margin="none"
              name={Filters.TO}
              component={DatePickerFormik}
              placeholder={Format.date_dayfirst}
              format={Format.date_dayfirst}
            />
          </Grid>
          <Grid item xs={3} classes={{ root: classes.filterSpacing }}>
            <Button
              title="Apply"
              color="primary"
              variant="contained"
              type="submit"
              className={classes.button}
            >
              Apply
            </Button>
          </Grid>
        </Grid>
      </Form>
    </Formik>
  );
};

const styles = (theme) => ({
  root: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  filterSpacing: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(2),
    width: '20%',
    backgroundColor: theme.palette.secondary.lighter,
    color: theme.palette.secondary.dark,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.common.white,
    },
  },
});

export default compose(withStyles(styles))(ActivityLogFilter);
